import { Award, Users, Heart } from 'lucide-react';
import aboutImg from '../assets/images/kuhinja12.webp';

export function About() {
  return (
    <section id="o-nama" className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col-reverse lg:grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Image */}
          <div className="relative w-full ">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={aboutImg}
                alt="Workshop"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            </div>
            <div className="-bottom-8 -right-8 w-64 h-64 bg-gray-900 rounded-2xl -z-10 hidden sm:absolute"></div>
          </div>

          {/* Right Side - Content */}
          <div>
            <h2 className="text-4xl md:text-5xl mb-6 text-gray-900">O nama</h2>
            
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Xemtio d.o.o je kompanija s dugogodišnjim iskustvom u izradi namještaja po mjeri. 
              Naš tim stručnjaka posvećen je stvaranju savršenih rješenja koja odgovaraju vašem 
              stilu života i prostoru.
            </p>
            
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Kombiniramo tradicionalno umijeće s modernom tehnologijom kako bismo vam pružili 
              namještaj vrhunske kvalitete koji će trajati generacijama.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
              <div className="text-center">
                <div className="w-20 h-20 sm:w-12 sm:h-12 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Award className="w-12 h-12 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-4xl sm:text-3xl mb-1 text-gray-900">10+</div>
                <div className="text-gray-600 text-lg sm:text-normal">Godina iskustva</div>
              </div>
              
              <div className="text-center">
                <div className="w-20 h-20 sm:w-12 sm:h-12 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Users className="w-12 h-12 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-4xl sm:text-3xl mb-1 text-gray-900">1000+</div>
                <div className="text-gray-600 text-lg sm:text-normal">Zadovoljnih klijenata</div>
              </div>
              
              <div className="text-center col-span-2 sm:col-span-1">
                <div className="w-20 h-20 sm:w-12 sm:h-12 bg-yellow-500 rounded-full flex items-center justify-center mx-auto mb-3">
                  <Heart className="w-12 h-12 sm:w-6 sm:h-6 text-white" />
                </div>
                <div className="text-4xl sm:text-3xl mb-1 text-gray-900">100%</div>
                <div className="text-gray-600 text-lg sm:text-normal">Posvećenost kvaliteti</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
